import { SettingItem } from "../../../services/soap/features/responses/GetFormSettingsResponse";
import { Divider, Flex } from "@adobe/react-spectrum";
import {
  CreateBillingItemsFields,
  CreateContextInfoFields,
  CreateCustomFormFieldForContextType,
  CreateCustomFormFields,
  CreatePersonFields,
  CreateProjectFields,
  CreateSalesItemsFields,
  CreateTechnologyItemsFields,
  CreateTrackingCodeFields,
} from "./ContextFields";
import { FPATemplateItem } from "../../../infra/protected/FPA/FPATemplateItem";
import { FPAData } from "../../../infra/protected/FPA/FPAData";
import { ContextNewDialogMode } from "./ContextNewDialog";
import { useState } from "react";

export interface IProjectContextFieldsProps {
  settings: SettingItem[];
  parentItem: FPAData | null;
  selectedItem?: FPATemplateItem;
  setFormData?: (key: string, value: any, isNew: boolean) => void;
  getFormData?: (key: string) => any;
  contextTypeFormId?: string;
  activityType?: number;
  projectType?: number;
  mode?: ContextNewDialogMode;
  /** Pre-filled items to display in the matching item-type section */
  initialData?: any[];
  /** Which item section the initialData belongs to */
  itemTypeTarget?: "salesItems" | "technologyItems" | "billingItems";
}

export function ProjectContextFields({
  settings,
  parentItem,
  selectedItem,
  setFormData,
  getFormData,
  contextTypeFormId,
  activityType,
  projectType,
  mode,
  initialData,
  itemTypeTarget,
}: IProjectContextFieldsProps) {
  const [projectId, setProjectId] = useState<number>(0);
  return (
    <Flex direction={"column"} gap={"size-100"}>
      <CreateProjectFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
        mode={mode}
        getFormData={getFormData}
      />
      <CreateTrackingCodeFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
      />
      <Divider size="M" />
      <CreateContextInfoFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        showFolders={true}
        showProjects={false}
        showActivities={false}
        activityType={activityType}
        setFormData={setFormData}
        projectType={projectType}
        onChangeProject={setProjectId}
      />
      <Divider size="M" />
      <CreateCustomFormFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
        getFormData={getFormData}
      />
      <CreateCustomFormFieldForContextType
        formId={contextTypeFormId}
        setFormData={setFormData}
        getFormData={getFormData}
      />
      <CreatePersonFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
      />
      <CreateSalesItemsFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
        projectId={projectId}
        initialData={itemTypeTarget === "salesItems" ? initialData : undefined}
      />
      <CreateBillingItemsFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
        projectId={projectId}
        initialData={
          itemTypeTarget === "billingItems" ? initialData : undefined
        }
      />
      <CreateTechnologyItemsFields
        settings={settings}
        parentItem={parentItem}
        selectedItem={selectedItem}
        setFormData={setFormData}
        projectId={projectId}
        initialData={
          itemTypeTarget === "technologyItems" ? initialData : undefined
        }
      />
    </Flex>
  );
}
